module.exports = __webpack_public_path__ + "static/img/pro_tab1.3db779b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab1.jpg
// module id = dNbO
// module chunks = 171